import { createContext, useContext } from 'react'

type Props = {
  value: any
  onChange: () => void
  clearKey: () => void
  validation: any
  onValidationChange: () => void
  isHidden: boolean
  children?: any
}

const defaultFormState = {
  value: {},
  onChange: () => {},
  clearKey: () => {},
  validation: {},
  onValidationChange: () => {},
}

const ValueCxt = createContext(defaultFormState.value)
const OnChangeCxt = createContext(defaultFormState.onChange)
const ClearKeyCxt = createContext(defaultFormState.clearKey)
const ValidationCxt = createContext(defaultFormState.validation)
const OnValidationChangeCxt = createContext(defaultFormState.onValidationChange)
const IsHiddenCxt = createContext(false)

const useFormValue = (): any => useContext(ValueCxt)
const useFormOnChange = () => useContext(OnChangeCxt)
const useFormClearKey = () => useContext(ClearKeyCxt)
const useFormValidation = () => useContext(ValidationCxt)
const useFormOnValidationChange = () => useContext(OnValidationChangeCxt)
const useFormIsHidden = () => useContext(IsHiddenCxt)

const FormStateProvider = (props: Props) => {
  const { value, onChange, clearKey, validation, onValidationChange, isHidden, children } = props

  return (
    <ValueCxt.Provider value={value}>
      <OnChangeCxt.Provider value={onChange}>
        <ClearKeyCxt.Provider value={clearKey}>
          <ValidationCxt.Provider value={validation}>
            <OnValidationChangeCxt.Provider value={onValidationChange}>
              <IsHiddenCxt.Provider value={isHidden}>{children}</IsHiddenCxt.Provider>
            </OnValidationChangeCxt.Provider>
          </ValidationCxt.Provider>
        </ClearKeyCxt.Provider>
      </OnChangeCxt.Provider>
    </ValueCxt.Provider>
  )
}

export {
  FormStateProvider,
  useFormValue,
  useFormOnChange,
  useFormClearKey,
  useFormValidation,
  useFormOnValidationChange,
  useFormIsHidden,
}
